const getDefaultState = () => {
    return {
      user: {},
      isCreate: true,
      eventId: '',
      feePayments: {},
    };
  };
  
  // initial state
  const state = getDefaultState();
  
  const mutations = {
    RESET_STATE(state) {
      Object.assign(state, getDefaultState());
    },
    SET_USER(state, payload) {
      state.user = payload;
    },
    CHANGE_CREATE_FEE_PAYMENT(state, payload){
      state.isCreate = payload;
    },
    SET_EVENT_ID(state, payload){
      state.eventId = payload
    },
    SET_FEE_PAYMENTS(state, payload){
      state.feePayments = payload
    }
  };
  
  const actions = {
    resetStateFeePayment({ commit }) {
      commit('RESET_STATE');
    },
    setUserFeePayment({ commit }, payload) {
      commit('SET_USER', payload);
    },
    changeIsCreateFeePayment({commit}, payload){
      commit('CHANGE_CREATE_FEE_PAYMENT', payload);
    },
    setEventId({commit}, payload){
      commit('SET_EVENT_ID', payload);
    },
    setFeePayments({commit}, payload){
      commit('SET_FEE_PAYMENTS', payload);
    }
  };
  
  export default {
    state,
    getters: {
      getUserFeePayment(state) {
        return state.user;
      },
      getFeePayments(state) {
        return state.feePayments;
      }
    },
    actions,
    mutations
  };
  